import {useDispatch, useSelector} from 'react-redux'
import { Link } from 'react-router-dom';
import { MetaData } from '../layouts/MetaData';
import { useEffect } from 'react';
import { loadUser } from '../../actions/UserActions';

    export const Profile = () => {
        const { user,isAuthenticated }  = useSelector((state) => state.authState);
        const dispatch = useDispatch();
         useEffect(()=>{
            dispatch(loadUser())
         },[dispatch,isAuthenticated])
         
        if (!isAuthenticated || !user) {
             return <h4>Loading or not authenticated...</h4>;
         }



        return (
        <div className="row justify-content-around mt-5 user-info">
                <MetaData title ={"My Profile"}/>
                <div className="col-12 col-md-3">
                    <figure className='avatar avatar-profile'>
                        <img className="rounded-circle img-fluid" src={user.avatar??'./images/avatar.jpg'} alt='' />
                    </figure>
                    <Link to="/myprofile/update" id="edit_profile" className="btn btn-primary btn-block my-5">
                        Edit Profile
                    </Link>
                </div>
        
                <div className="col-12 col-md-5">
                    <h4>Full Name</h4>
                    <p>{user.name}</p>
        
                    <h4>Email Address</h4>
                    <p>{user.email}</p>

                    <h4>Joined</h4>
                    <p>{String(user.createdAt).substring(0, 10)}</p>

                    <Link to="/orders" className="btn btn-danger btn-block mt-5">
                        My Orders
                    </Link>

                    <Link to="/myprofile/changepassword" className="btn btn-primary btn-block mt-3">
                        Change Password
                    </Link>
                </div>
            </div>
    )
    }
